<template>
  <div class="add-button-container">
    <button 
      type="button" 
      @click="handleButtonClick" 
      class="btn-add"
      ref="addButton"
    >
      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
      </svg>
    </button>
    
    <!-- Context Menu - Only for authenticated users -->
    <div 
      v-if="showContextMenu && isAuthenticated" 
      class="context-menu"
      ref="contextMenu"
      @click.stop
    >
      <button
        type="button"
        @click="handleAddNew"
        class="context-menu-item"
      >
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 4v16m8-8H4"></path>
        </svg>
        {{ addNewLabel }}
      </button>

      <button
        type="button"
        @click="handleAddFromMaster"
        class="context-menu-item"
      >
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
        </svg>
        {{ addFromMasterLabel }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContextMenu',
  props: {
    isAuthenticated: {
      type: Boolean,
      required: true
    },
    addNewLabel: {
      type: String,
      default: 'Add New Entry'
    },
    addFromMasterLabel: {
      type: String,
      default: 'Add from Profile'
    }
  },
  emits: ['add-new', 'add-from-master'],
  data() {
    return {
      showContextMenu: false
    }
  },
  mounted() {
    // Close context menu when clicking outside
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    handleButtonClick() {
      if (this.isAuthenticated) {
        this.toggleContextMenu()
      } else {
        this.handleAddNew()
      }
    },

    toggleContextMenu() {
      this.showContextMenu = !this.showContextMenu
    },

    handleClickOutside(event) {
      if (this.$refs.contextMenu && !this.$refs.contextMenu.contains(event.target) && 
          this.$refs.addButton && !this.$refs.addButton.contains(event.target)) {
        this.showContextMenu = false
      }
    },

    handleAddNew() {
      this.$emit('add-new')
      this.showContextMenu = false
    },

    handleAddFromMaster() {
      this.$emit('add-from-master')
      this.showContextMenu = false
    },

    // Add method to handle upload errors
    handleUploadError(error) {
      if (error.status === 404 && error.message?.includes('Entry not found')) {
        // Entry was deleted, refresh the CV data
        this.$emit('refresh-cv-data')
        return {
          success: false,
          message: 'This entry no longer exists. Please refresh the page and try again.',
          shouldRefresh: true
        }
      }
      return {
        success: false,
        message: error.message || 'Upload failed. Please try again.',
        shouldRefresh: false
      }
    }
  }
}
</script>

<style scoped>
.add-button-container {
  @apply relative inline-block;
}

.context-menu {
  @apply absolute top-full right-0 mt-1 z-50 min-w-[200px] overflow-hidden py-1 bg-white dark:bg-gray-950 border border-zinc-200 dark:border-zinc-700 rounded-xl;
  animation: contextMenuSlideIn 0.15s ease-out;
}

@keyframes contextMenuSlideIn {
  from {
    opacity: 0;
    transform: translateY(-4px) scale(0.97);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.context-menu-item {
  @apply flex items-center gap-2.5 w-full px-3.5 py-2.5 text-left text-sm font-medium text-zinc-600 dark:text-zinc-300 hover:bg-zinc-50 dark:hover:bg-zinc-800 hover:text-primary dark:hover:text-primary-300 transition-colors cursor-pointer;
}

.context-menu-item svg {
  @apply flex-shrink-0 text-zinc-400 transition-colors;
}

.context-menu-item:hover svg {
  @apply text-primary dark:text-primary-300;
}
</style>